import type BaseDto from '../interface/IBaseDto';
import type { ExternalBaseDataType, InternalBaseDataType } from '../interface/IBaseDto';

type BaseType = BaseDto<any, ExternalBaseDataType, InternalBaseDataType>;

function isEntity<Entity extends BaseType>(object: unknown): object is Entity {
    if (object === undefined || object === null || typeof object !== 'object') {
        return false;
    }

    const record = object as Partial<Entity>;

    return (
        typeof record.flatten === 'function' &&
        typeof record.apply === 'function' &&
        typeof record.mappings === 'function'
    );
}

export default isEntity;
